import script from "./SizeQuantityControl.vue?vue&type=script&setup=true&lang=js"
export * from "./SizeQuantityControl.vue?vue&type=script&setup=true&lang=js"

import "./SizeQuantityControl.vue?vue&type=style&index=0&id=6479f8a6&lang=scss"

const __exports__ = script;

export default __exports__